<template>
  <VDialog v-model="isShowModal" max-width="600" persistent>
    <VToolbar color="primary" density="compact">
      <VToolbarTitle>
        <VIcon icon="mdi-plus" class="mr-2" />
        Add Answer
      </VToolbarTitle>
      <VSpacer />
      <VBtn icon="mdi-close" variant="text" @click="handleCancel" :disabled="isLoading" />
    </VToolbar>
    <VCard>
      <VCardItem>
        <VForm v-model="formValid" @submit.prevent class="mb-3 my-2">
          <VRow>
            <VCol cols="12">
              <div class="my-2 mx-2">
                <QuillEditor
                  :content="form.value"
                  theme="snow"
                  :placeholder="Enter"
                  style="height: 150px"
                  contentType="html"
                  :disabled="isLoading"
                  @update:content="
                    (val) => {
                      form.value = val;
                    }
                  "
                />
              </div>
            </VCol>
            <VCol cols="12">
              <VBtn :loading="isLoading" class="mb-2" type="submit" color="primary" block flat @click="handleSubmit()">
                Add
              </VBtn>
              <VBtn :disabled="isLoading" color="grey-100" block flat @click="handleCancel()">Cancel</VBtn>
            </VCol>
          </VRow>
        </VForm>
      </VCardItem>
    </VCard>
  </VDialog>
</template>

<script>
import { mapActions } from 'vuex';
// Service
import invitesService from '@/services/invites-service/invites.service';
// Text
import { successAddAnswerToQuestionText, errorAddAnswerToQuestionText } from '@/text/snackbarsText';
export default {
  name: 'AddAnswerModal',

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    inviteId: {
      type: String
    },
    categoryId: {
      type: String
    },
    questionId: {
      type: String
    }
  },

  emits: ['update:modelValue', 'saved'],

  computed: {
    isShowModal() {
      return this.modelValue;
    }
  },

  data() {
    return {
      isLoading: false,
      form: {
        value: ''
      },
      formValid: false
    };
  },

  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    async handleSubmit() {
      if (this.form.value?.length) {
        this.isLoading = true;
        try {
          const answerData = {
            inviteId: this.inviteId,
            questionId: this.questionId,
            categoryId: this.categoryId,
            supplierAnswer: this.form.value
          };
          await invitesService.addSupplierAnswer(answerData);
          this.showSnackbar({ text: successAddAnswerToQuestionText, color: 'green' });
          this.handleSuccess();
        } catch (err) {
          console.error(err);
          this.showSnackbar({ text: errorAddAnswerToQuestionText, color: 'red' });
        } finally {
          this.isLoading = false;
        }
      } else {
        this.showSnackbar({ text: 'Answer required', color: 'red' });
      }
    },

    handleSuccess() {
      this.$emit('saved');
      this.handleCancel();
    },

    handleCancel() {
      this.$emit('update:modelValue', false);
      this.resetForm();
    },

    resetForm() {
      this.form = {
        value: ''
      };
    }
  }
};
</script>
